import React from "react";
import { Button } from "../../general/Button/Button";

interface StartTradingButtonProps {
  isVisible: boolean;
}

export const StartTradingButton: React.FC<StartTradingButtonProps> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <Button
      navigateTo="/trade"
      data-testid="start-trading-btn"
      text={"Start Trading"}
      size={"Medium"}
      height={44}
    />
  );
};
